<template>
    <nav class="link-list" :class="[bemFacets]">
        <ul class="link-list--collection u-reset">
            <li class="link-list--item" v-for="(link, index) in links" :key="index">
                <conditional-link class="link-list--link u-reset" v-bind="link">
                    {{ link.label }}
                    <base-icon class="link-list--icon" size="medium" :symbol="getIconByType(link.type)"/>
                </conditional-link>
            </li>
        </ul>
    </nav>
</template>

<script>
    import ConditionalLink from 'framework/components/conditional-link/conditional-link.vue';
    import bemMixin from 'framework/mixins/bem';

    const ICONS_BY_TYPE = {
        file: 'file',
        external: 'externallink',
        internal: 'arrowforward',
        default: 'arrowforward',
    };

    export default {
        components: { ConditionalLink },
        mixins: [bemMixin('link-list')],
        props: {
            /** @type {ILink[]} */
            links: {
                type: Array,
                required: true,
            },
        },
        methods: {
            getIconByType(type) {
                return ICONS_BY_TYPE[type] ? ICONS_BY_TYPE[type] : ICONS_BY_TYPE.default;
            },
        },
    };
</script>
